export const iconFontAwesomeCodingBath = (
	<i className="fa-solid fa-bath"></i>
);
